import {IRequestAuth} from 'core/api/index'

/**
 * Augment (or create) a headers object with an authorization header for the given request auth.
 * Token auth is given precedence, followed by admin key auth.
 * @param {IRequestAuth} auth
 * @param {{}} headers
 */
export const authHeaders = (auth: IRequestAuth, headers = {}) => {
  if (auth.token) {
    return {
      ...headers,
      Authorization: `Bearer ${auth.token}`,
    }
  } else if (auth.adminKey) {
    return {
      ...headers,
      'x-luminopia-admin-key': auth.adminKey,
    }
  } else return headers
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/utils.ts